import React from "react";
import { ContainerDiv } from "./Container.elements";

export default function Container({ children }) {
  return <ContainerDiv>{children}</ContainerDiv>;
}
